import React from "react";
import { Link } from "react-router-dom";

const ElementSidbarHr = () => {

  return (
    <li>
      <hr className="my-2 border-0 h-[0.7px] bg-transparent bg-gradient-to-r from-transparent via-textColor dark:via-darkTextColor to-transparent" />
    </li>
  );
};

export default ElementSidbarHr;
